import React, { useEffect } from "react";
import { useDoubtActions } from "../../../hooks/useDoubts";
import "./FilterBlog.css";
import "./DoubtReport.css";

const CloseIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M3.33337 3.33334L12.6667 12.6667"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M12.6667 3.33334L3.33337 12.6667"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

const BlockDoubtModal = ({ open, onClose, authorName, doubtId, language = "EN" }) => {
  const actions = useDoubtActions(doubtId, language);

  if (!open) return null;

  const handleBlock = async () => {
    if (doubtId) {
      await actions.blockDoubt.mutateAsync();
      onClose();
    }
  };

  const isPending = actions.blockDoubt.isPending;

  return (
    <div className="filter-blog-overlay" onClick={onClose}>
      <div
        className="filter-blog-modal doubtReport-modal"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="close-btn2 text-end unlock-close-btn">
          <button
            type="button"
            className="btn-close"
            onClick={onClose}
            aria-label="Close"
          />
        </div>

        {/* Icon */}
        <div className="premium-icon daily-icon iconnn  blockIcon ms-auto me-auto d-flex">
          <i className="fa-solid fa-ban"></i>
        </div>

        {/* Title */}
        <h5 className="fw-bold blackText mb-2 ms-auto me-auto text-center">Block</h5>

        <p className="add-doubt-modal__message text-center blockp">
          You wont see any doubt posts, answer or comments from {authorName || "this user"}
        </p>

        <div className="filter-blog-modal__footer doubtReport-footer">
          <button
            type="button"
            className="filter-blog-modal__action filter-closeed bg-transparent Blackbutton-border"
            onClick={onClose}
          >
            <span>Cancel</span>
          </button>

          <button
            type="button"
            className="filter-blog-modal__action filter-blog-modal__action--apply blockDoubt-btn"
            onClick={handleBlock}
            disabled={isPending}
          >
            <span>{isPending ? "Blocking..." : "Block Doubt"}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlockDoubtModal;
